import { FC, useState } from 'react';
import { format } from 'date-fns';

import SvgTrash from '@/assets/icons/Trash';
import { ConfirmationDialog } from '@/components/dialogs/generic/confirmation';

import usePutWtsEenheden from './usePutWtsEenheden';
import { WtsEenheid } from './WtsTypes';

import styles from './WtsTableRow.module.css';
type WtsTableRowProps = {
  wtsEenheid: WtsEenheid;
};
const WtsTableRow: FC<WtsTableRowProps> = ({ wtsEenheid }) => {
  const { deleteWts } = usePutWtsEenheden();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const aangemaaktOpDate = new Date(wtsEenheid.aangemaaktOp);
  // Need to format 2 times because we can't parse with a litteral "'" in the formatted output, so we just join them on "'" :).
  const aangemaaktOp = [format(aangemaaktOpDate, 'dd-MM-'), format(aangemaaktOpDate, 'yy H:mm')].join(`'`);

  const confirmDelete = () => {
    deleteWts([wtsEenheid.nummer]);
    setShowDeleteDialog(false);
  };

  return (
    <>
      <div className={styles.wtsRow}>
        <div className={styles.wtsEenheidNummer}>{wtsEenheid.nummer}</div>
        <div className={styles.wtsDatumDeleteRow}>
          <div>{aangemaaktOp}</div>
          <div>
            <button
              data-testid={`deleteWtsFor${wtsEenheid.nummer}`}
              className={styles.wtsTrashButton}
              aria-label={`Verwijder uitsluiting voor ${wtsEenheid.nummer}`}
              onClick={() => setShowDeleteDialog(true)}
            >
              <SvgTrash className={styles.wtsTrashIcon} />
            </button>
          </div>
        </div>
      </div>
      <ConfirmationDialog
        title='Weet je het zeker?'
        showDialog={showDeleteDialog}
        handleOpenChange={setShowDeleteDialog}
        message='Deze WTS uitsluiting wordt verwijderd.'
        confirmText='Verwijderen'
        confirmButtonType='destructive'
        cancelText='Annuleren'
        onCancel={() => setShowDeleteDialog(false)}
        onConfirm={confirmDelete}
      />
    </>
  );
};
export default WtsTableRow;
